import _ from '@/utils/lodash-optimized'

import {
  HISTORY_LOADING_START,
  HISTORY_LOADING_END,
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAIL,
  UPDATE_HISTORY,
  MARK_READ,
  HISTORY_EMPTY,
  PATCH_HISTORY
} from './actions.js'

const initialState = {
  loading: false,
  notifications: [],
  loadMoreVisible: true,
  lastRequestedAt: undefined
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case HISTORY_LOADING_START:
      return {
        ...state,
        loading: true,
        lastRequestedAt: new Date()
      }
    case HISTORY_LOADING_END:
      return {
        ...state,
        loading: false
      }
    case GET_HISTORY:
      return {
        ...state,
        loading: true
      }
    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        loading: false,
        error: null,
        loadMoreVisible: true
      }
    case GET_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case UPDATE_HISTORY:
      return {
        ...state,
        notifications: action.notifications
      }
    case PATCH_HISTORY:
      return {
        ...state,
        notifications: [ ...action.notifications, ...state.notifications ]
      }
    case HISTORY_EMPTY:
      return {
        ...state,
        loadMoreVisible: false
      }
    case MARK_READ:
      return {
        ...state,
        notifications: _.filter(state.notifications, n => n.id !== action.id)
      }
    default:
      return state
  }
}
